import axios from "axios";

const BASE = "/api/dashboard";

export function getSummary() {
  return axios.get(`${BASE}/summary`);
}
